import { Typography, Space, Card, Row, Col } from 'antd';
import MainLayout from '@/components/Layout/MainLayout';
import { isOctaPharmaProgram, getManufacturerByProgram } from "@/libs/util";
import { programLabels } from "@/config";
import useGlobalConfig from '@/store/global';

const { Title, Paragraph } = Typography;

const GrifolsPrograms = ['alphanine', 'gamunex', 'prolastin', 'xembify'];

const HomePage = () => {
  const { program } = useGlobalConfig();
  const name = program.name;
  const isOctaPharma = isOctaPharmaProgram(name);

  const MedicalDescription = () => {
    return (
      <div>
        Pharmacies must&nbsp;
        <a href="/provider_support" className="!text-sky-700 hover:underline">register here</a>
        &nbsp;to request assistance for their eligible&nbsp;
        {programLabels[name].name}
        &nbsp;patients covered under medical benefits.
      </div>
    )
  }

  const PharmacyDescription = () => {

    if (isOctaPharma) {
      return <p>If the patient’s primary payer is billed through the pharmacy benefits, submit the claim to the primary payer first. If the patient requires copay assistance, submit the balance due to Medmonk as a secondary payer (COB- Coordination of Benefits), using the BIN: 016664, PCN: MEDMONK, and Cardholder ID: MEDMONK.</p>
    }

    if (name === "alyglo" || name === "coagadex" || name === "gammaked" || name === "gammaplex") {
      return <p>If the patient’s primary payer drug claim is billed under pharmacy benefits, submit the claim to the primary payer first. If the patient requires copay assistance, submit the balance due to Medmonk as a secondary payer (COB - Coordination of Benefits) using the BIN: 016664, PCN: MEDMONK, and Cardholder ID: MEDMONK</p>
    }

    return <p>
      Pharmacies, please bill using BIN: 016664, PCN: MEDMONK, and Cardholder ID: MEDMONK to request assistance for eligible
      &nbsp;{programLabels[name].name}&nbsp;
      patients covered under pharmacy benefits.
    </p>;
  }

  const TimelyDescription = () => {
    let dispenseDate = 30;
    let EOBDay = 180;

    switch (name) {
      case "alphanine":
      case "prolastin":
        dispenseDate = 45;
        EOBDay = 180;
        break;
      case "gamunex":
      case "xembify":
        dispenseDate = 60;
        EOBDay = 180;
        break;
      default:
        dispenseDate = 30;
        EOBDay = 120;
    }

    if (isOctaPharma) {
      return <p>
        Claims must be received within 180 days of the dispense date. For
        medical benefit requests, the claim form (CMS-1500) must be uploaded along
        with the EOB to document the charges.
      </p>
    }

    return <p>
      Claims must be received within {dispenseDate} days of dispense date. For medical benefits, EOBs must be submitted within {EOBDay} days of claim submission.
    </p>
  }

  const PayerDescription = () => {
    return <p>
      Please use this&nbsp;
      <a target="_blank"
        href="/Medmonk_Payer_Sheet_v3.0.pdf"
        className="!text-sky-700 hover:underline">
        Payer Sheet
      </a>
      &nbsp;if your organization does not already have Medmonk enlisted as a payer.
    </p>
  }

  const infoItems = [
    {
      key: "1",
      category: "Medical Benefits",
      description: <MedicalDescription />
    },
    {
      key: "2",
      category: "Pharmacy Benefits",
      description: <PharmacyDescription />
    },
    {
      key: "3",
      category: 'Timely Filing',
      description: <TimelyDescription />
    },
    {
      key: '4',
      category: 'Payer Sheet',
      description: <PayerDescription />
    },
  ];

  return (
    <MainLayout>
      <div className="mb-6">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Title level={5}>IF YOUR PATIENT IS COVERED UNDER</Title>

          <Row gutter={[16, 16]}>
            {infoItems.map(item => (
              <Col xs={24} sm={24} md={12} key={item.key}>
                <Card title={item.category} style={{ height: '100%' }}>
                  <Paragraph>{item.description}</Paragraph>
                </Card>
              </Col>
            ))}

            {GrifolsPrograms.includes(name) && (
              <Col xs={24} sm={24} md={12} key="5">
                <Card title="ICD Codes" style={{ height: "100%" }}>
                  <Paragraph>
                    Please find the list of&nbsp;
                    <a target="_blank"
                      href={programLabels[name].codeUrl}
                      className="!text-sky-700 hover:underline"
                    >covered ICD codes</a>
                    &nbsp;under the {programLabels[name].label} Program.
                  </Paragraph>
                </Card>
              </Col>
            )}
          </Row>

          <Card>
            <Paragraph>
              This program is subject to change or discontinuation by&nbsp;
              <b>{getManufacturerByProgram(name)}</b>
              &nbsp;at any time, for any reason, and with or without prior notice.
              This portal is administered by&nbsp;
              <a target="_blank" href="https://medmonk.com/" className="!text-sky-700 hover:underline">Medmonk</a>
              &nbsp;for The {programLabels[name].label} Program.
            </Paragraph>
          </Card>
        </Space>
      </div>
    </MainLayout>
  );
};

export default HomePage;
